import { DateTime } from 'luxon';
import { getDateForIms } from 'js/hooks/useFormatter/helpers';

import { ANOTHER_PERIOD_VALUE, LAST_24_HOURS_VALUE } from './constants';

export const intoDate = (date = new Date()) => typeof date === 'number' ? new Date(date) : date;
export const startOfDay = (date = new Date()) => intoDate(date).setHours(0, 0, 0, 0);

export const get3MonthsBefore = (now = new Date()) => {
    const hour = now.getUTCHours();
    const resultDay = new Date(now.getTime());

    resultDay.setDate(1);
    resultDay.setMonth(now.getMonth() - 3);

    const daysInMonth = new Date(resultDay.getFullYear(), resultDay.getMonth() + 1, 0).getDate();

    if (daysInMonth < now.getDate()) {
        resultDay.setMonth(resultDay.getMonth() + 1);
    } else {
        resultDay.setDate(now.getDate());
    }

    resultDay.setUTCHours(hour);

    return resultDay;
};

export const formatDateForIms = time => {
    const timeRaw = time ? new Date(time) : new Date();

    timeRaw.setMilliseconds(0);

    return getDateForIms(timeRaw);
};

export const getAnotherPeriodDates = (from, until) => {
    const fromDate = intoDate(from);
    const untilDate = intoDate(until);

    return {
        from: new Date(Date.UTC(fromDate.getFullYear(), fromDate.getMonth(), fromDate.getDate(), 0, 0, 0, 0)),
        until: new Date(Date.UTC(untilDate.getFullYear(), untilDate.getMonth(), untilDate.getDate(), 23, 59, 59, 0))
    };
};

export const getRequestDates = ({ period, startDate, endDate }) => {
    const isAnotherPeriod = period === ANOTHER_PERIOD_VALUE;
    const { from, until } = getAnotherPeriodDates(startDate, endDate);

    return {
        requestStartDate: isAnotherPeriod ? from : startDate,
        requestEndDate: isAnotherPeriod ? until : endDate
    };
};

export const getSecondBulkForSixMonthsDates = () => ({
    startDate: get3MonthsBefore(get3MonthsBefore()),
    endDate: get3MonthsBefore()
});

export const getInitialPeriodData = () => {
    const currentDate = DateTime.local();
    const days = LAST_24_HOURS_VALUE;

    return {
        period: days,
        startDate: currentDate.minus({ days }).toJSDate(),
        endDate: currentDate.toJSDate()
    };
};
